// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"464":"cf6f4072","779":"d7117682","781":"cb4c8413","972":"a9522c09"}[chunkId] + ".css";
};